import { BlockUI, NgBlockUI }       from 'ng-block-ui';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { ApiService }      from '../api/api.service';
import { MessagesService } from '../messages/messages.service';
import { SmsCostModel }    from './models/sms-cost';
import { SmsPurchase }     from './models/sms-purchase';

@Component({
  selector   : 'wor-buy-sms',
  template: require('./company.buy-sms.component.html')
})
export class BuySmsComponent implements OnInit {
  public isPurchasing = false;

  // SMS credit is sold in blocks of 100. sms_logs#purchase rejects anything
  // that is not a whole number of blocks, so the modal enforces the same rule
  // rather than letting the backend error be the first the workshop hears of it.
  readonly blockSize = 100;

  totalCost = 0;

  @BlockUI('buySmsBlock') block : NgBlockUI;

  @Input() cost : SmsCostModel;
  @Input() count: number;

  purchase : SmsPurchase;

  constructor (
    public activeModal      : NgbActiveModal,
    private apiService      : ApiService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.purchase = {
      agree   : false,
      cost    : this.cost,
      quantity: 0
    };
  }

  calculateCost ( quantity = this.purchase.quantity ) : void {
    if (quantity < 500) {
      this.totalCost = this.purchase.cost.high_sms_price * quantity;
    }
    else if (quantity >= 500 && quantity < 5000) {
      this.totalCost = this.purchase.cost.medium_sms_price * quantity;
    }
    else {
      this.totalCost = this.purchase.cost.low_sms_price * quantity;
    };
  }

  confirm () : void {
    this.block.start();

    this.isPurchasing = true;

    this.apiService.get('/sms_logs/purchase', [ this.purchase.agree, this.purchase.quantity ])
    .then(() => this.apiService.get('/sms_logs/current_sms_count'))
    .then(( count : number ) => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.PURCHASE_SUCCESSFUL'), 'success');

      this.activeModal.close(count);
    })
    .catch(err => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();

      this.isPurchasing = false;
    });
  }

  isQuantityValid () : boolean {
    const quantity = Number(this.purchase.quantity);

    return Number.isInteger(quantity)
      && quantity >= this.blockSize
      && quantity % this.blockSize === 0;
  }

  // Rounds up to the next whole block once the workshop leaves the field, so a
  // part block is corrected in front of them rather than silently disabling Buy.
  // Mirrors the backend, which quotes the shortfall rounded up to whole blocks.
  normaliseQuantity () : void {
    const quantity = Number(this.purchase.quantity);

    if (!quantity || quantity < 0) {
      return;
    }

    this.purchase.quantity = Math.max(
      this.blockSize,
      Math.ceil(quantity / this.blockSize) * this.blockSize
    );

    this.calculateCost(this.purchase.quantity);
  }
}